import { role as types, request as HTTP_REQUEST } from '../../constants/types';
import { requestAxios } from './helpers';
const _request = async (path, dispatch, type = HTTP_REQUEST.GET, body = {}, config = {}) => {
    dispatch(setLoading());
    try {
        const response = await requestAxios(type, path, body, config);
        dispatch(setError(null));
        const { data } = response;
        if (data instanceof Array) dispatch({ type: types.GET, payload: data })
        else if (data instanceof Object) {
            const { roles } = data;
            if (roles) return dispatch(JSON.stringify(roles))
            else {
                const { role } = data;
                switch (type) {
                    case HTTP_REQUEST.POST: dispatch({ type: types.PUSH, payload: role })
                        break;
                    case HTTP_REQUEST.PUT: dispatch({ type: types.PUT, payload: role })
                        break;
                    case HTTP_REQUEST.DELETE: dispatch({ type: types.DELETE, payload: role })
                        break;
                    default: dispatch({ type: types.ROLE, payload: role })
                        break;
                }
            }
        }
    } catch (error) {
        let { message } = error?.response?.data || error;
        message instanceof Object && (message = error.message)
        dispatch(setError(message))
    }
    dispatch(setLoading());
}
export const setRole = role => dispatch => {
    dispatch({
        type: types.ROLE,
        payload: role
    });
}
export const setLoading = () => dispatch => {
    dispatch({ type: types.LOADING });
}
export const setError = error => dispatch => {
    dispatch({
        type: types.ERROR,
        payload: error
    });
}
export const listAllRoles = () => async dispatch => {
    await _request('/role', dispatch);
}
export const findRoleByIdAndUser = roleId => async dispatch => {
    await _request(`/user/role/${roleId}`, dispatch);
}
export const findRoleById = roleId => async dispatch => {
    await _request(`/role/${roleId}`, dispatch);
}
export const listAllRolesByUser = () => async dispatch => {
    await _request('/user/role', dispatch);
}
export const listAllRolesByContain = text => async dispatch => {
    const config = { params: { search: text } };
    await _request('/user/role/search', dispatch, HTTP_REQUEST.GET, null, config);
}
export const registerRole = () => async (dispatch, getState) => {
    const { role: { role }, user: { user } } = getState();
    const config = { headers: { token: localStorage.getItem('AUTHORIZATION_TOKEN_BLOG') } };
    await _request('/role', dispatch, HTTP_REQUEST.POST, { ...role, userId: user.id }, config);
}
export const updateRole = roleId => async (dispatch, getState) => {
    const { role: { role } } = getState();
    await _request(`/user/role/${roleId}`, dispatch, HTTP_REQUEST.PUT, role);
}
export const deleteRole = roleId => async dispatch => {
    await _request(`/user/role/${roleId}`, dispatch, HTTP_REQUEST.DELETE);
}